import { render, staticRenderFns } from "./TcEventShow.vue?vue&type=template&id=a7d185f0&"
import script from "./TcEventShow.vue?vue&type=script&lang=js&"
export * from "./TcEventShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7d185f0')) {
      api.createRecord('a7d185f0', component.options)
    } else {
      api.reload('a7d185f0', component.options)
    }
    module.hot.accept("./TcEventShow.vue?vue&type=template&id=a7d185f0&", function () {
      api.rerender('a7d185f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcEventShow.vue"
export default component.exports